import { normalizeUrl } from '@ribajs/utils'
import { setPageAndSearchParameters } from '../utils/index.js'

export class ShopifyBlogService {
  /**
   * Get the blog url by blog url or handle, page number and other additional url search parameters
   * @param blogHandleOrUrl
   * @param page
   * @param searchParameter
   * @returns
   */
  public static getBlogUrl(
    blogHandleOrUrl: string,
    page = 1,
    searchParameter?: URLSearchParams,
  ) {
    const locale = (window as any)?.Shopify?.routes?.root || '/'
    let _url = blogHandleOrUrl.includes('/blogs/')
      ? normalizeUrl(blogHandleOrUrl).url
      : `${locale}blogs/${blogHandleOrUrl}`

    if (!_url?.startsWith('http')) {
      _url = window.location.protocol + '//' + window.location.host + _url
    }

    const url = new URL(_url)

    return setPageAndSearchParameters(url, page, searchParameter)
  }
}
